import { useState } from "react";

import type { RiskControls } from "~/v3-poc/api/riskControls.schema";
import {
  getRiskControlsSummary,
  type RiskControlSelection,
  type RiskControlsSummary,
  toRiskControlSelection,
} from "./riskControls.model";

export interface UseRiskControlsButtonControllerArgs {
  controls: RiskControls | undefined;
}

export interface RiskControlsButtonController {
  open: boolean;
  current: RiskControlSelection;
  summary: RiskControlsSummary;
  openDialog: () => void;
  setOpen: (open: boolean) => void;
}

export const useRiskControlsButtonController = ({
  controls,
}: UseRiskControlsButtonControllerArgs): RiskControlsButtonController => {
  const [open, setOpen] = useState(false);
  const current = toRiskControlSelection(controls);
  const summary = getRiskControlsSummary(current);

  return {
    open,
    current,
    summary,
    openDialog: () => {
      setOpen(true);
    },
    setOpen,
  };
};
